let importExport = false;

/** call once at the top of your import/export page */
export const setImportExport = v => (importExport = !!v);

/** anywhere else you need to know */
export const isImportExport = () => importExport;
